import * as amplitude from "@amplitude/analytics-react-native"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { BadgeM } from "@common/components/badge/BadgeM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { useDisconnectFromLive } from "../../engine/live/room/useDisconnectFromLive"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useApiStatus } from "@common/hooks/useApiStatus"
import PermissionBanner from "@common/livekit/components/PermissionBanner"
import { useDisconnecting } from "@common/livekit/components/useDisconnecting"
import { hasValueGreaterThanZero } from "@common/liveMode/LiveChat"
import { TIME_SINCE_LAST_CALL_MINUTES } from "@common/liveMode/StudentsList"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    playASound,
    removeInCallUsers,
    setInCallUsers,
    setIsLiveModeEnabled,
    setIsTyping,
    setLiveParticipants,
    setTypingUser,
} from "@data/redux/actions/liveMode"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import { hasFeature } from "@data/utility/Utils"
import { useConnectionState, useRoomContext } from "@livekit/components-react"
import { useNavigation, useRoute } from "@react-navigation/native"
import { ConnectionState } from "livekit-client"
import moment from "moment"
import React, { useContext, useEffect } from "react"
import { Dimensions, View } from "react-native"
import { TouchableOpacity } from "react-native-gesture-handler"
import { ActivityIndicator, Badge } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import live from "../../../assets/icons/generic/live.png"
import { liveService } from "../../data/services/liveService"
import { hasRole } from "../../data/utility/ability"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"
import useThrottledSetAttributes from "../../engine/live/room/useThrottledSetAttributes"
import { useCurrentActivity } from "../hooks/useCurrentActivity"
import { theme } from "../theme/theme"
import LiveSessionDialogComponent from "./LiveSessionDialogComponent"

export const onExitPress = (action1, action2, isFinalized, tutor, user) => {
    const standardTitle = "Veux-tu vraiment quitter ?"
    const standardButton1 = "Quitter le LIVE"

    const studentTitle = standardTitle
    const studentText = isFinalized
        ? null
        : `${tutor?.display_name} n'a pas encore mis fin à la session`
    const studentButton1 = standardButton1

    const tutorTitle = isFinalized
        ? standardTitle
        : "Veux-tu mettre fin au LIVE ?"
    const tutorText = isFinalized
        ? null
        : `Si tu clôtures le LIVE, il ne sera plus accessible aujourd'hui.`
    const tutorButton3 = isFinalized ? standardButton1 : "Quitter sans clôturer"
    const tutorButton1 = isFinalized ? null : "Clôturer et envoyer rapports"

    const title = hasRole(user, "student") ? studentTitle : tutorTitle
    const text = hasRole(user, "student") ? studentText : tutorText
    const button1 = hasRole(user, "student") ? studentButton1 : tutorButton1
    const button3 = hasRole(user, "student") ? null : tutorButton3

    DialogM.show({
        champion: "zoe",
        variant: "main",
        text1: title,
        text2: text,
        buttonText1: button1,
        buttonColor1: hasRole(user, "student")
            ? theme.colors.primary
            : theme.colors.error,
        onPress: hasRole(user, "student") ? action1 : action2,
        buttonText2: "Annuler",
        buttonText3: button3,
        buttonColor3: theme.colors.primary,
        onPress3: hasRole(user, "student") ? null : action1,
        exitButton: true,
    })
}

const LiveModeHeader = (props) => {
    const {
        buttonsDisabled = false,
        headerNavigation,
        headerRoute,
        setMiniMode = () => {},
        noSubHeader = false,
    } = props
    const navigation = headerNavigation ?? useNavigation()
    const route = headerRoute ?? useRoute()
    const tabs = ["presence", "messages"]

    const color = buttonsDisabled
        ? theme.colors.grey
        : noSubHeader
        ? theme.colors.white
        : theme.colors.primary

    const liveSession = props.currentLiveSession
    const isV4 = hasFeature(liveSession?.live_room, "checkpoint-rh")

    const timesSinceLastCallAlert = Object?.values(
        props.timesSinceLastCall ?? {}
    )?.filter((x) => x >= TIME_SINCE_LAST_CALL_MINUTES * 60)?.length
    const dimensions = useContext(DimensionsContext)
    const isHandRaised = props.raisedHands?.includes(props.user?.id)
    const isFinalized = props.todayLiveSessionLogs?.find(
        (log) => log?.action === "finalized_live_session"
    )
    const { sendLiveKitData: triggerFinalizeLive } = useLiveKitEventSender()
    const { getCurrentActivity, setCurrentActivity } = useCurrentActivity()
    const currentActivity = getCurrentActivity()

    const raiseHandApi = liveServiceV2.raiseHandV2

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null
    const isInSilentMode =
        !props.soundModeParticipants?.includes(props.user?.id) &&
        hasRole(props.user, "student")

    useApiStatus(
        liveService.raiseHand, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {} // success callback
    )

    useEffect(() => {
        if (hasRole(props.user, "tutor")) noNotesStudentsList()
    }, [props.notes, props.inCallUsers])

    const noNotesStudentsList = () => {
        let notes = []
        liveSession?.users
            ?.filter((user) => !user?.is_tutor)
            ?.forEach((user) => {
                if (
                    !user?.tutor_notes?.find(
                        (n) => moment(n?.created_at).day() === liveMoment.day()
                    )
                )
                    notes.push(user.display_name)
            })
    }
    const exit = () => {
        setCurrentActivity(null, true)
        if (hasRole(props.user, "tutor"))
            props.apiRequest(liveService.leaveLiveSession, {
                id: props.liveSessionId,
            })
        if (hasRole(props.user, "student"))
            if (
                moment().isAfter(liveMoment.clone().add(15, "minutes")) ||
                moment().isSameOrAfter(liveMoment.clone().add(15, "minutes"))
            ) {
                setTimeout(() => {
                    DialogM.show({
                        text1: `Qu'as-tu pensé de cette session LIVE avec ${props.currentLiveSession.tutor?.display_name}`,
                        component: (
                            <LiveSessionDialogComponent
                                navigation={navigation}
                            />
                        ),
                        hideButton1: true,
                        buttonText2: "Pas maintenant",
                        onPressBack: () => {
                            props.apiRequest(liveService.leaveLiveSession, {
                                id: props.liveSessionId,
                            })
                        },
                        exitButton: true,
                    })
                }, 200)
            } else {
                props.apiRequest(liveService.leaveLiveSession, {
                    id: props.liveSessionId,
                })
            }
    }
    useApiStatus(
        liveService.sendSatisfaction, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {},
        () => {}
    )
    const endSession = () => {
        navigation.push("todo-check")
    }
    const connectionState = useConnectionState()
    const disconnecting = useDisconnecting()

    const isOnline = connectionState?.toString() === ConnectionState.Connected
    const connectionStateText =
        connectionState?.toString() === ConnectionState.Reconnecting
            ? "Reconnexion..."
            : disconnecting
            ? "Déconnexion..."
            : connectionState?.toString() === ConnectionState.Connected
            ? "Connecté.e au LIVE"
            : "Connexion..."

    const room = useRoomContext()
    const { disconnectFromLive } = useDisconnectFromLive()
    const setAttributesThrottled = useThrottledSetAttributes()
    useApiStatus(
        liveService.leaveLiveSession, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            disconnectFromLive()
        } // success callback
    )
    useApiStatus(
        liveService.finalizeLiveSession, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData) => {
            triggerFinalizeLive("finalizeLive", {
                id: props.user?.id,
            })
            navigation.push("end-session-tutor", {
                occurrence_id: successData?.id,
            })
            props.apiRequest(liveService.leaveLiveSession, {
                id: props.liveSessionId,
            })
        } // success callback
    )

    return (
        <View
            style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <View
                style={{
                    width: noSubHeader
                        ? null
                        : dimensions?.width > 800
                        ? dimensions?.width
                        : dimensions?.width - 40,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <TouchableRippleM
                    style={{
                        alignItems: "center",
                    }}
                    disabled={true}
                >
                    <>
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <IconImageM
                                source={live}
                                width={22}
                                style={{
                                    tintColor: theme.colors.success,
                                }}
                            />
                            <TextM
                                fontSize={16}
                                fontWeight={"ExtraBold"}
                                color={theme.colors.success}
                                style={{
                                    paddingLeft: 5,
                                }}
                            >
                                LIVE
                            </TextM>
                        </View>
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <TextM
                                fontSize={12}
                                fontWeight={"Light"}
                                ellipsizeMode={"tail"}
                                color={theme.colors.success}
                                style={{
                                    paddingLeft: 8,
                                    maxWidth: 70,
                                }}
                            >
                                {liveSession?.live_room?.name}
                            </TextM>
                        </View>
                    </>
                </TouchableRippleM>
                {props.leaveLiveSessionRequest ||
                props.finalizeLiveSessionRequest ? (
                    <ActivityIndicator
                        color={theme.colors.primary}
                        style={{ marginHorizontal: 7 }}
                    />
                ) : (
                    <TouchableOpacity
                        style={{
                            alignItems: "center",
                            marginLeft: 10,
                        }}
                        onPress={() => {
                            amplitude.track("button.clicked." + "exit_live")
                            setMiniMode(true)
                            onExitPress(
                                exit,
                                endSession,
                                isFinalized,
                                liveSession?.tutor,
                                props.user
                            )
                        }}
                        disabled={buttonsDisabled}
                    >
                        <FontAwesome5
                            solid
                            name="sign-out-alt"
                            size={32}
                            color={theme.colors.error}
                            style={{
                                opacity: buttonsDisabled ? 0.2 : 1,
                                transform: [{ rotate: "180deg" }],
                            }}
                        />
                    </TouchableOpacity>
                )}
                <TouchableOpacity
                    onPress={() => {
                        setMiniMode(true)
                        if (
                            tabs.includes(route.name) &&
                            route.name !== "messages"
                        ) {
                            navigation.replace("messages", {
                                userId: hasRole(props.user, "tutor")
                                    ? null
                                    : liveSession?.tutor?.id,
                            })
                        } else {
                            navigation.navigate("messages", {
                                userId: hasRole(props.user, "tutor")
                                    ? null
                                    : liveSession?.tutor?.id,
                            })
                        }
                    }}
                    style={{
                        marginLeft: 10,
                    }}
                    disabled={buttonsDisabled}
                >
                    <FontAwesome5
                        solid
                        name="comments"
                        size={32}
                        color={color}
                    />
                    {(hasValueGreaterThanZero(
                        liveSession?.unread_private_messages_count
                    ) ||
                        liveSession?.unread_messages_count > 0) && (
                        <Badge
                            size={15}
                            style={{
                                backgroundColor: theme.colors.error,
                                color: theme.colors.white,
                                position: "absolute",
                                top: 0,
                                right: -4,
                            }}
                        />
                    )}
                </TouchableOpacity>

                {props.raiseHandRequest ||
                props.raiseHandV2Request ||
                props.createConversationRequest ? (
                    <ActivityIndicator
                        color={theme.colors.primary}
                        style={{ marginHorizontal: 7 }}
                    />
                ) : (
                    <TouchableOpacity
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: 10,
                            borderColor: color,
                            backgroundColor: isHandRaised ? color : null,
                            paddingLeft: 4,
                            marginLeft: 10 - 4,
                            paddingRight: 6,
                            marginRight: -6,
                        }}
                        disabled={
                            buttonsDisabled ||
                            props.createConversationRequest ||
                            hasRole(props.user, "tutor")
                        }
                        onPress={() => {
                            setAttributesThrottled({
                                raise_hand_source: "",
                                display_name: props.user?.display_name,
                            }).catch((e) =>
                                console.error("Error setting attributes", e)
                            )
                            props.apiRequest(
                                raiseHandApi,
                                { id: props.liveSessionId },
                                { raised: !isHandRaised }
                            )
                        }}
                    >
                        <FontAwesome5
                            name="hand-paper"
                            solid
                            size={32}
                            style={{
                                opacity:
                                    hasRole(props.user, "tutor") &&
                                    !buttonsDisabled
                                        ? 0.2
                                        : 1,
                            }}
                            color={isHandRaised ? theme.colors.accent : color}
                        />
                        {props.raisedHands?.length > 0 && (
                            <BadgeM
                                count={props.raisedHands?.length}
                                style={{
                                    backgroundColor: theme.colors.error,
                                    color: theme.colors.white,
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                }}
                            />
                        )}
                    </TouchableOpacity>
                )}
                {hasRole(props.user, "tutor") && (
                    <TouchableOpacity
                        onPress={() => {}}
                        style={{
                            marginLeft: 10,
                        }}
                        disabled={true}
                    >
                        <FontAwesome5
                            solid
                            name="stopwatch"
                            size={32}
                            style={{
                                opacity: buttonsDisabled ? 1 : 0.2,
                            }}
                            color={color}
                        />
                        {timesSinceLastCallAlert > 0 && (
                            <BadgeM
                                count={timesSinceLastCallAlert}
                                style={{
                                    backgroundColor: theme.colors.error,
                                    color: theme.colors.white,
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                }}
                            />
                        )}
                    </TouchableOpacity>
                )}
            </View>

            {!noSubHeader && (
                <View
                    style={{
                        backgroundColor: theme.colors.successLightMore,
                        width: Dimensions?.get("window")?.width,
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        bottom: -12,
                        flexDirection: "row",
                        borderBottomWidth: 1,
                        borderColor: theme.colors.lightMore,
                        gap: 40,
                    }}
                >
                    <View
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                        }}
                    >
                        <Badge
                            style={{
                                backgroundColor: isOnline
                                    ? theme.colors.success
                                    : theme.colors.light,
                                marginRight: 4,
                                marginBottom: 1,
                            }}
                            size={10}
                        />
                        <TextM fontSize={10}>
                            {connectionStateText}
                            {isFinalized
                                ? " - Cette session LIVE est terminée"
                                : ""}
                        </TextM>
                    </View>
                    <PermissionBanner />
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        successes: state.data.staticData?.successes,
        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        conferenceToken: state.liveMode?.conferenceToken,
        participants: state.liveMode?.liveParticipants,
        inCallUsers: state.liveMode?.inCallUsers,
        raisedHands: state.liveMode?.raisedHands,
        sound: state.liveMode?.sound,
        timesSinceLastCall: state.liveMode?.timesSinceLastCall,
        notes: state.data.tutors?.notes,
        soundMode: state.liveMode?.soundMode,
        isAudioMuted: state.liveMode?.isAudioMuted,
        callPortal: state.liveMode?.callPortal,
        leaveLiveSessionRequest: state.api.leaveLiveSession?.request,
        finalizeLiveSessionRequest: state.api.finalizeLiveSession?.request,
        raiseHandRequest: state.api.raiseHand?.request,
        raiseHandV2Request: state.api.raiseHandV2?.request,
        pusherStatus: state.pusher?.status,
        todayLiveSessionLogs: state.liveMode?.todayLiveSessionLogs,
        callKeepUUID: state.liveMode?.callKeepUUID,
        sendSatisfactionSuccess: state.api.sendSatisfaction?.success,
        activityTemplates: state.data.staticData?.activity_templates,
        soundModeParticipants: state.liveMode.soundModeIds,
        cameraState: state?.camera,
        todo_activities: state.data.currentUser?.object.todo_activities,
        createConversation: state.api.createConversation,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
    setLiveParticipants,
    setIsTyping,
    setTypingUser,
    setInCallUsers,
    removeInCallUsers,
    playASound,
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveModeHeader)
